const categoryLandingNewsTaglines = {
  education: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in education'
  },
  health: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in health'
  },
  entertainment: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in entertainment'
  },
  money: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in finance'
  },
  work: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in the workforce'
  },
  entrepreneurs: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women who own their own businesses'
  },
  'womens-rights': {
    tagline: 'Below you will find some interesting stories and information on what\'s happening in women\'s and girls\' rights'
  },
  motherhood: {
    tagline: 'Below you will find some interesting stories and information on what\'s happening for women in motherhood'
  },
  girls: {
    tagline: 'Below you will find some interesting stories and information on people making a difference in the lives of girls everywhere'
  },
  invest: {
    tagline: 'Below you will find some interesting stories and information on who are investing in women entrepreneurs and powerful philanthropic causes that support women and girls'
  },
};

export default categoryLandingNewsTaglines;



// WEBPACK FOOTER //
// ./src/misc/categoryLandingNewsTaglines.js